import Util from "./Util.js";
//
import { gsap } from "./Util.js";
import { CustomEase } from "./Util.js";

class Menu extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setVars();
    this.events();
    this.addCurrentClass();
  }

  setVars() {
    this.btn = document.querySelector(".btn-menu");
    this.menu = document.querySelector(".menu");
  }

  events() {
    this.btn.addEventListener("click", () => {
      if (document.documentElement.classList.contains("is-menu-open")) {
        document.documentElement.classList.remove("is-menu-open");
        window.SCROLL_INSTANCE.lenis.start();
        gsap.set("body", {
          overflow: "auto",
        });
      } else {
        document.documentElement.classList.add("is-menu-open");
        window.SCROLL_INSTANCE.lenis.stop();
        gsap.set("body", {
          overflow: "hidden",
        });
        const hideTxt = this.website.isDesktop ? this.menu.querySelectorAll(".sp-none .hide-txt") : this.menu.querySelectorAll(".pc-none .hide-txt");
        gsap.fromTo(
          hideTxt,
          {
            y: "100%",
          },
          {
            y: "0%",
            duration: 1.2,
            ease: CustomEase.create("custom", "M0,0 C0.419,0 0.107,1 1,1 "),
            stagger: 0.01,
          }
        );
      }
    });
  }

  addCurrentClass() {
    // const target = this.menu.querySelectorAll(".menu-collection-target");
    // if (window.location.href.includes("/products")) {
    //   target[1].classList.add("current");
    // }
    // if (window.location.href.includes("/green")) {
    //   target[0].classList.add("current");
    // }
  }
}

export default Menu;
